function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open")
  );

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });

  if (summary.closest("header-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary")
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);

      if (window.matchMedia("(max-width: 990px)")) {
        document.documentElement.style.setProperty(
          "--viewport-height",
          `${window.innerHeight}px`
        );
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    this.mainDetailsToggle
      .querySelectorAll(".submenu-open")
      .forEach((submenu) => {
        submenu.classList.remove("submenu-open");
      });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header =
      this.header || document.getElementById("shopify-section-header-v2");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom"
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );
    this.header.classList.add("menu-open");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove("menu-open");
  }
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      // Check if the video has autoplay attribute but is not starting to play
      if (
        deferredElement.tagName === "VIDEO" &&
        deferredElement.hasAttribute("autoplay") &&
        deferredElement.paused
      ) {
        deferredElement.play();
      }
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.orientation =
      this.slider.getAttribute("data-orientation") || "horizontal";

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );

    if (this.sliderItemsToShow.length < 2) return;
    if (this.orientation === "vertical") {
      this.sliderItemOffset =
        this.sliderItemsToShow[1].offsetTop -
        this.sliderItemsToShow[0].offsetTop;
      this.slidesPerPage = Math.floor(
        (this.slider.clientWidth - this.sliderItemsToShow[0].offsetTop) /
          this.sliderItemOffset
      );
    } else {
      this.sliderItemOffset =
        this.sliderItemsToShow[1].offsetLeft -
        this.sliderItemsToShow[0].offsetLeft;
      this.slidesPerPage = Math.floor(
        (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
          this.sliderItemOffset
      );
    }
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    if (this.orientation === "vertical") {
      this.currentPage =
        Math.round(this.slider.scrollTop / this.sliderItemOffset) + 1;
    } else {
      this.currentPage =
        Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;
    }

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    const sliderScroll =
      this.orientation === "vertical"
        ? this.slider.scrollTop
        : this.slider.scrollLeft;
    if (this.isSlideVisible(this.sliderItemsToShow[0]) && sliderScroll === 0) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
      )
    ) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }
  }

  isSlideVisible(element, offset = 0) {
    if (this.orientation === "vertical") {
      const lastVisibleSlide =
        this.slider.clientHeight + this.slider.scrollTop - offset;
      return (
        element.offsetTop + element.clientHeight <= lastVisibleSlide &&
        element.offsetTop >= this.slider.scrollTop
      );
    } else {
      const lastVisibleSlide =
        this.slider.clientWidth + this.slider.scrollLeft - offset;
      return (
        element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
        element.offsetLeft >= this.slider.scrollLeft
      );
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    const sliderScroll =
      this.orientation === "vertical"
        ? this.slider.scrollTop
        : this.slider.scrollLeft;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? sliderScroll + step * this.sliderItemOffset
        : sliderScroll - step * this.sliderItemOffset;
    let scrollToPosition = { left: this.slideScrollPosition };
    if (this.orientation === "vertical") {
      scrollToPosition = { top: this.slideScrollPosition };
    }
    this.slider.scrollTo(scrollToPosition);
  }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");

    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link")
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this))
    );
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute("data-autoplay") === "true")
      this.setAutoPlay();

    this.discount();
  }

  discount() {
    // Récupérer le chemin de l'URL
    const path = window.location.pathname;
    const pathParts = path.split("/");

    console.log(path, pathParts);

    // Vérifier si l'URL contient "/discount/MONCODE"
    if (pathParts.length > 2 && pathParts[1] === "discount") {
      const discountCode = pathParts[2]; // MONCODE
      document.cookie = "applied_discount=" + discountCode + "; path=/";

      // Modifier l'image dynamiquement (ajuster le sélecteur selon ton HTML)
      const imageElement = document.querySelector("#image-selector"); // Remplace par l'ID ou la classe réelle
      const mobileImageElement = document.querySelector(
        "#mobile-image-selector"
      );

      if (imageElement) {
        imageElement.src = "URL_DE_L_IMAGE_APRÈS_REDUCTION"; // Remplace par l'URL de l'image après promo
      }
      if (mobileImageElement) {
        mobileImageElement.src = "URL_DE_L_IMAGE_APRÈS_REDUCTION_MOBILE"; // Remplace par l'URL mobile
      }
    }
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener(
      "click",
      this.autoPlayToggle.bind(this)
    );
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === "previous") {
      const sliderScroll =
        this.orientation === "vertical"
          ? this.slider.scrollTop
          : this.slider.scrollLeft;
      const firstItemProportion =
        this.orientation === "vertical"
          ? this.sliderFirstItemNode.clientHeight
          : this.sliderFirstItemNode.clientWidth;
      this.slideScrollPosition =
        sliderScroll + firstItemProportion * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }

    let scrollToPosition = { left: this.slideScrollPosition };
    if (this.orientation === "vertical") {
      scrollToPosition = { top: this.slideScrollPosition };
    }
    this.slider.scrollTo(scrollToPosition);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    if (this.sliderControlButtons[this.currentPage - 1]) {
      this.sliderControlButtons[this.currentPage - 1].classList.add(
        "slider-counter__link--active"
      );
    }

    if (this.sliderControlButtons[this.currentPage - 1]) {
      this.sliderControlButtons[this.currentPage - 1].setAttribute(
        "aria-current",
        true
      );
    }
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed
    );
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow
      );
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow
      );
    }
  }

  autoRotateSlides() {
    const sliderScroll =
      this.orientation === "vertical"
        ? this.slider.scrollTop
        : this.slider.scrollLeft;
    const slideProportion =
      this.orientation === "vertical"
        ? this.slider.querySelector(".slideshow__slide").clientHeight
        : this.slider.querySelector(".slideshow__slide").clientWidth;
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : sliderScroll + slideProportion;
    let scrollToPosition = { left: slideScrollPosition };
    if (this.orientation === "vertical") {
      scrollToPosition = { top: slideScrollPosition };
    }
    this.slider.scrollTo(scrollToPosition);
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll("a");
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute("tabindex");
          });
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute("tabindex", "-1");
          });
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const sliderScroll =
      this.orientation === "vertical"
        ? this.slider.scrollTop
        : this.slider.scrollLeft;
    const firstItemProportion =
      this.orientation === "vertical"
        ? this.sliderFirstItemNode.clientHeight
        : this.sliderFirstItemNode.clientWidth;
    const slideScrollPosition =
      sliderScroll +
      firstItemProportion *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    let scrollToPosition = { left: slideScrollPosition };
    if (this.orientation === "vertical") {
      scrollToPosition = { top: slideScrollPosition };
    }
    this.slider.scrollTo(scrollToPosition);
  }
}

customElements.define("slideshow-component", SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(
      `[id^="MediaGallery-${this.dataset.section}"]`
    );
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(
        `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        true
      )
    );

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    );
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`
    );
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(":checked").value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll(".product-form__input")];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(":checked").value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.innerText = input.getAttribute("value");
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace(
          "[value]",
          input.getAttribute("value")
        );
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, "text/html");
        const priceDestination = document.getElementById(
          `price-${this.dataset.section}`
        );
        const priceSource = html.getElementById(
          `price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const priceButtonDestination = document.getElementById(
          `price-2-${this.dataset.section}`
        );
        const priceButtonSource = html.getElementById(
          `price-2-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );

        const stickyButton = document.getElementById(`sticky-button`);

        if (stickyButton) {
          const stickyButtonSource = html.getElementById(`sticky-button`);
          stickyButton.innerHTML = stickyButtonSource.innerHTML;
        }

        const skuSource = html.getElementById(
          `Sku-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const skuDestination = document.getElementById(
          `Sku-${this.dataset.section}`
        );
        const inventorySource = html.getElementById(
          `Inventory-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const inventoryDestination = document.getElementById(
          `Inventory-${this.dataset.section}`
        );

        if (priceSource && priceDestination)
          priceDestination.innerHTML = priceSource.innerHTML;
        if (priceButtonSource && priceButtonDestination)
          priceButtonDestination.innerHTML = priceButtonSource.innerHTML;
        if (inventorySource && inventoryDestination)
          inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle(
            "visibility-hidden",
            skuSource.classList.contains("visibility-hidden")
          );
        }

        const price = document.getElementById(`price-${this.dataset.section}`);
        const priceButton = document.getElementById(
          `price-2-${this.dataset.section}`
        );

        if (price) price.classList.remove("visibility-hidden");

        if (priceButton) priceButton.classList.remove("visibility-hidden");

        if (inventoryDestination)
          inventoryDestination.classList.toggle(
            "visibility-hidden",
            inventorySource.innerText === ""
          );

        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.soldOut
        );
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(
      `Inventory-${this.dataset.section}`
    );
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("visibility-hidden");
    if (inventory) inventory.classList.add("visibility-hidden");
    if (sku) sku.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.classList.remove("disabled");
      } else {
        input.classList.add("disabled");
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }
}

customElements.define("variant-radios", VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (
            !this.querySelector("slideshow-component") &&
            this.classList.contains("complementary-products")
          ) {
            this.remove();
          }

          if (html.querySelector(".grid__item")) {
            this.classList.add("product-recommendations--loaded");
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("product-recommendations", ProductRecommendations);

class ProgressBar extends HTMLElement {
  constructor() {
    super();
    this.variantId = this.getAttribute("data-product");
    this.goalAmount = parseFloat(this.getAttribute("data-goal-amount"));
    this.cartTotal = parseFloat(this.getAttribute("data-cart-total"));
    this.goalAchieved = this.getAttribute("data-goal") === "true";
    this.quantity = parseInt(this.getAttribute("data-quantity"));
    this.isActivated = this.getAttribute("data-is-activated") === "true";

    this.cart =
      document.querySelector("cart-notification") ||
      document.querySelector("cart-drawer");
  }

  connectedCallback() {
    setTimeout(() => {
      this.checkGoal();
    }, 300);
  }

  checkGoal() {
    if (!this.isActivated && this.quantity > 0) {
      this.updateProductFromCart(this.variantId);
      return;
    }
    if (!this.isActivated) return;

    if (this.quantity > 1) {
      // Goal achieved and product is in cart, update quantity
      this.updateProductFromCart(this.variantId, 1);
    }
    if (!this.goalAchieved && this.cartTotal >= this.goalAmount) {
      // Goal achieved, add product to cart
      this.addProductToCart(this.variantId);
    }
    if (this.goalAchieved && this.cartTotal < this.goalAmount) {
      // Goal not achieved but product is in cart, remove it
      this.updateProductFromCart(this.variantId);
    }
  }

  addProductToCart(variantId) {
    const body = JSON.stringify({
      items: [
        {
          id: variantId,
          quantity: 1,
        },
      ],
      sections: this.cart.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_add_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => response.json())
      .then((data) => {
        if (this.cart) this.cart.renderContents(data);
      })
      .catch((error) => console.error("Error adding product to cart:", error));
  }

  updateProductFromCart(variantId, quantity = 0) {
    const body = JSON.stringify({
      id: variantId,
      quantity: quantity,
      sections: this.cart.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => response.json())
      .then((data) => {
        if (this.cart) this.cart.renderContents(data);
      })
      .catch((error) =>
        console.error("Error removing product from cart:", error)
      );
  }
}
customElements.define("progress-bar", ProgressBar);

class Bundles extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.getAttribute("section-id");
    this.items = this.querySelectorAll(".bundle");
    this.input = document.querySelector("#variant-id-input");
    this.price = document.querySelector(`#price-2-${this.sectionId}`);
    this.productInfo = document.querySelector(`.product__info-container`);

    this.sellingPlanBlock = document.querySelector("[data-selling-plan-block]");
    if (this.sellingPlanBlock) {
      this.selectedSellingPlanId = null;
      this.productUrl = this.getAttribute("data-product-url");
      const subscriptionPlansScript = document.querySelector(
        `script#subscription-plans-${this.sectionId}`
      );
      if (subscriptionPlansScript) {
        this.sellingPlansJSON = JSON.parse(subscriptionPlansScript.textContent)[
          "selling_plans"
        ];
      }

      const sellingPlanInputs = this.sellingPlanBlock.querySelectorAll(
        '[name="ma-selling-plan-group"]'
      );
      sellingPlanInputs.forEach((sellingPlanInput) => {
        sellingPlanInput.addEventListener("click", () => {
          let quantity = 1;
          this.items.forEach((item) => {
            if (item.classList.contains("active")) {
              quantity = item.getAttribute("quantity");
            }
          });

          document.dispatchEvent(
            new CustomEvent("selling-plans:change", {
              bubbles: true,
              detail: {
                quantity: quantity,
              },
            })
          );
        });
      });
    }

    this.buttonBuy = document.querySelector(
      ".product-form__submit .product-info__price"
    );
    this.stickyButtonBuy = document.querySelector(
      ".sticky-button .product-info__price"
    );

    this.percent = document.querySelector(".percent");

    this.items.forEach((item) => {
      item.addEventListener("click", async () => {
        if (this.sellingPlanBlock) {
          if (item.getAttribute("variant-id") !== this.dataset.variantId) {
            this.sellingPlanBlock.classList.add("hidden");
            // repasser au plan d'achat unique
            const singlePurchaseInput = document.querySelector(
              '[value="single-purchase"]'
            );
            if (singlePurchaseInput) {
              singlePurchaseInput.click();
            }
          } else {
            this.sellingPlanBlock.classList.remove("hidden");
            // revenir sur la variant avec abonnement : re-sélectionner la subscription
            // seulement si c'est l'option par défaut (réglage du bloc)
            const subscriptionInput = this.sellingPlanBlock.hasAttribute(
              "data-default-subscription"
            )
              ? this.sellingPlanBlock.querySelector(
                  '[name="ma-selling-plan-group"]:not([value="single-purchase"])'
                )
              : null;
            if (subscriptionInput && !subscriptionInput.checked) {
              subscriptionInput.click();
            }
          }
        }
        if (!item.classList.contains("disabled")) {
          this.items.forEach((element) => {
            element.classList.remove("active");
          });
          item.classList.add("active");
          this.input.value = item.getAttribute("variant-id");

          if (item.getAttribute("price")) {
            const price = item.getAttribute("price");
            this.price.innerHTML =
              "&nbsp;&nbsp;&nbsp;-&nbsp;&nbsp;&nbsp;" + price;
          }

          if (this.stickyButtonBuy) {
            this.stickyButtonBuy.innerHTML =
              "&nbsp;" + item.getAttribute("price");
          }

          if (item.getAttribute("compared-at")) {
            const priceElement = this.productInfo.querySelector(".price");
            if (priceElement) {
              priceElement.classList.add("price--on-sale");
            }

            const priceSale = this.productInfo.querySelector(".price__sale");
            if (priceSale) {
              priceSale.style.display = "block";
            }

            const priceRegular =
              this.productInfo.querySelector(".price__regular");
            if (priceRegular) {
              priceRegular.style.display = "none";
            }

            const itemPrice = this.productInfo.querySelector(
              ".price__sale .price-item.price-item--regular"
            );
            if (itemPrice) {
              itemPrice.innerHTML = item.getAttribute("compared-at");
            }

            const salePrice = this.productInfo.querySelector(
              ".price__sale .price-item--last"
            );
            if (salePrice) {
              salePrice.innerHTML = item.getAttribute("price");
            }
          }

          if (
            item.getAttribute("data-percent") &&
            document.querySelector(".percent")
          ) {
            const priceElement = this.productInfo.querySelector(".price");
            if (priceElement) {
              priceElement.classList.add("price--on-sale");
            }

            const percentElement = this.productInfo.querySelector(".percent");
            if (percentElement) {
              percentElement.classList.remove("hidden");
            }

            const percentValue =
              this.productInfo.querySelector(".percent__value");
            if (percentValue) {
              percentValue.innerHTML = item.getAttribute("data-percent");
            }
          }

          if (!item.getAttribute("compared-at")) {
            const priceElement = this.productInfo.querySelector(".price");
            if (priceElement) {
              priceElement.classList.remove("price--on-sale");
            }

            const percentElement = this.productInfo.querySelector(".percent");
            if (percentElement) {
              percentElement.classList.add("hidden");
            }

            const priceSale = this.productInfo.querySelector(".price__sale");
            if (priceSale) {
              priceSale.style.display = "none";
            }

            const priceRegular =
              this.productInfo.querySelector(".price__regular");
            if (priceRegular) {
              priceRegular.style.display = "block";
            }

            const regularPrice = this.productInfo.querySelector(
              ".price__regular .price-item--regular"
            );
            if (regularPrice) {
              regularPrice.innerHTML = item.getAttribute("price");
            }
          }

          await this.getVariantData(
            item.getAttribute("variant-id"),
            item.getAttribute("product-url"),
            this.sectionId
          );
          document.dispatchEvent(
            new CustomEvent("selling-plans:change", {
              bubbles: true,
              detail: {
                quantity: item.getAttribute("quantity"),
              },
            })
          );
        }
      });
    });

    this.setupSellingPlans();
  }

  async getVariantData(requestedVariantId, url, section_id) {
    try {
      const response = await fetch(
        `${url}?variant=${requestedVariantId}&section_id=${section_id}`
      );
      const responseText = await response.text();
      const html = new DOMParser().parseFromString(responseText, "text/html");

      const priceDestination = document.querySelector(`#price-${section_id}`);
      const priceSource = html.querySelector(`#price-${section_id}`);

      if (priceSource && priceDestination) {
        priceDestination.innerHTML = priceSource.innerHTML;
      }

      const stickyDestination = document.querySelector("sticky-button");
      const stickySource = html.querySelector("sticky-button");

      if (stickyDestination && stickySource) {
        stickyDestination.innerHTML = stickySource.innerHTML;
        stickyDestination.init();
      }

      // Switch live du contenu de pack : on swappe le pack-contents du produit-pack cliqué
      const packDestination = document.querySelector(
        `#pack-contents-${section_id}`
      );
      const packSource = html.querySelector(`#pack-contents-${section_id}`);

      if (packSource && packDestination) {
        packDestination.innerHTML = packSource.innerHTML;
      }
    } catch (error) {
      console.error("Error fetching variant data:", error);
    }
  }

  updatePrices(e) {
    const { quantity } = e.detail;
    const unitPrice = parseInt(this.dataset.unitPriceCents) || 0;
    const unitCompareAtPrice =
      parseInt(this.dataset.unitCompareAtPriceCents) || 0;
    const plansPriceWrapper = this.sellingPlanBlock?.querySelector(
      "[data-price-wrapper]"
    );

    let selectedPlanInput = this.sellingPlanBlock?.querySelector(
      '[name="ma-selling-plan-group"]:checked'
    );
    let price = "";
    let compareAtPrice = `${(unitCompareAtPrice / 100).toFixed(2)}${
      this.dataset.currencySymbol
    }`;

    if (
      this.sellingPlanBlock &&
      selectedPlanInput?.value !== "single-purchase"
    ) {
      let priceCents = 0;
      for (let i = 0; i < quantity; i++) {
        priceCents += Math.round(
          (unitPrice *
            (100.0 - this.selectedSellingPlan["price_adjustments"][0].value)) /
            100
        );
      }

      let compareAtPriceCents = 0;
      for (let i = 0; i < quantity; i++) {
        compareAtPriceCents += Math.round(
          (unitCompareAtPrice *
            (100.0 - this.selectedSellingPlan["price_adjustments"][0].value)) /
            100
        );
      }

      price = `${(priceCents / 100).toFixed(2)}${this.dataset.currencySymbol}`;
      compareAtPrice = `${(compareAtPriceCents / 100).toFixed(2)}${
        this.dataset.currencySymbol
      }`;

      const salePriceElement = document.querySelector(".price-item--sale");
      if (salePriceElement) {
        salePriceElement.innerHTML = price;
      }

      const comparePriceElement = document.querySelector(
        ".price-item--compare-price"
      );
      if (comparePriceElement) {
        comparePriceElement.innerHTML = `${(unitPrice / 100).toFixed(2)}${
          this.dataset.currencySymbol
        }`;
      }

      if (this.stickyButtonBuy) {
        this.stickyButtonBuy.innerHTML = "&nbsp;" + price;
      }
      this.price.innerHTML = `&nbsp;&nbsp;-&nbsp;&nbsp;${price}`;
    } else {
      this.items.forEach((item) => {
        if (item.classList.contains("active")) {
          price = item.getAttribute("price");
          compareAtPrice = item.getAttribute("compared-at");
        }
      });

      const salePriceElement = document.querySelector(".price-item--sale");
      if (salePriceElement) {
        salePriceElement.innerHTML = price;
      }

      const comparePriceElement = document.querySelector(
        ".price-item--compare-price"
      );
      if (comparePriceElement) {
        comparePriceElement.innerHTML = compareAtPrice;
      }

      if (plansPriceWrapper) {
        const priceElements = plansPriceWrapper.querySelectorAll(
          "[data-product-price]"
        );
        priceElements.forEach((element) => {
          element.textContent = price;
        });
      }

      this.price.innerHTML = `&nbsp;&nbsp;-&nbsp;&nbsp;${price}`;
      if (this.stickyButtonBuy) {
        this.stickyButtonBuy.innerHTML = "&nbsp;" + price;
      }
    }
  }

  setupSellingPlans() {
    if (!this.sellingPlanBlock) {
      return;
    }

    this.toggles = this.sellingPlanBlock.querySelectorAll(
      "[data-toggles-group]"
    );
    if (!this.toggles) {
      return;
    }

    this.toggles.forEach((toggle) => {
      toggle.addEventListener("click", (e) => {
        const value = e.target.value.toString();
        const selectedGroup = this.sellingPlanBlock.querySelector(
          `[data-group-toggle="${value}"]`
        );
        const groups =
          this.sellingPlanBlock.querySelectorAll(`[data-group-toggle]`);

        if (selectedGroup) {
          selectedGroup.classList.remove("hidden");
          const first = selectedGroup.querySelector(`[name="selling_plan"]`);
          if (first) {
            first.click();
          }
        }

        groups.forEach((group) => {
          if (group !== selectedGroup) {
            group.classList.add("hidden");
            const plans = group.querySelectorAll(`[name="selling_plan"]`);
            plans.forEach((plan) => {
              plan.checked = false;
            });
          }
        });
      });
    });

    const plans = this.sellingPlanBlock.querySelectorAll(
      `[name="selling_plan"]`
    );
    plans.forEach((plan) => {
      plan.addEventListener("change", async (e) => {
        const planId = e.target.value;
        const currentPlan = this.sellingPlansJSON.find(
          (x) => x.id === parseInt(planId)
        );
        if (!currentPlan) {
          console.warn(`Plan with id ${planId} does not exist`);
          return;
        }
        this.selectedSellingPlan = currentPlan;
        const reductionPercent =
          this.selectedSellingPlan["price_adjustments"][0].value;
        const sellingPlanDiscountContainer =
          this.sellingPlanBlock.querySelector("[data-discount]");
        if (sellingPlanDiscountContainer) {
          sellingPlanDiscountContainer.textContent = `-${reductionPercent}%`;
        }

        this.dispatchEvent(
          new CustomEvent("selling-plans:change", {
            bubbles: true,
            detail: {
              quantity:
                this.querySelector(".bundle.active")?.getAttribute(
                  "quantity"
                ) || "1",
            },
          })
        );
      });
    });

    document.addEventListener(
      "selling-plans:change",
      this.updatePrices.bind(this)
    );
    if (plans.length > 0) {
      plans[0].dispatchEvent(new MouseEvent("change"));
    }
  }
}
customElements.define("bundles-component", Bundles);

class StickyButton extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.addToCart = this.querySelector(".product-form__submit");
    this.originalAddToCart = document.querySelector(
      ".product button[name='add']"
    );
    if (this.addToCart) {
      this.addToCart.addEventListener("click", () => {
        this.originalAddToCart?.click();
      });
    }
  }

  connectedCallback() {
    const targetToObserve = document.querySelector(".product-form__buttons");

    this.intersecting = false;

    const callback = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.intersecting = true;
        }
        if (!entry.isIntersecting) {
          this.intersecting = false;
        }
      });
    };

    const observer = new IntersectionObserver(callback, {
      root: null,
      rootMargin: "0px",
      threshold: 1.0,
    });

    if (targetToObserve) {
      observer.observe(targetToObserve);
    }

    window.addEventListener("scroll", () => {
      this.classList.toggle("active", window.scrollY > 0 && !this.intersecting);
    });
  }
}

customElements.define("sticky-button", StickyButton);

class ScrollInTop extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", () => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    });
  }
}

customElements.define("scroll-in-top", ScrollInTop);

class CartProductSlider extends HTMLElement {
  constructor() {
    super();
    this.SliderId = this.getAttribute("slider-id");
    this.slider = new Splide(`.card-product-slider--${this.SliderId}`, {
      perPage: 1,
      perMove: 1,
      pagination: true,
      arrows: false,
      drag: true,
    }).mount();
  }
}
customElements.define("card-product-slider", CartProductSlider);

class FreeProduct extends HTMLElement {
  constructor() {
    super();
    this.products = JSON.parse(this.getAttribute("data-products"));
    this.cart = document.querySelector("cart-drawer");
    console.log("products", this.products);
    if (this.products.length > 0) {
      this.product_1 = this.products[0];
    }
    if (this.products.length > 1) {
      this.product_2 = this.products[1];
    }
  }

  connectedCallback() {
    setTimeout(() => {
      this.checkGoal();
    }, 300);
  }

  checkGoal() {
    const itemsToAdd = [];
    if (
      this.product_1 &&
      this.product_1.should_be_added &&
      this.product_1.quantity === 0
    ) {
      itemsToAdd.push({
        id: this.product_1.id,
        quantity: 1,
      });
    }
    if (
      this.product_1 &&
      this.product_1.quantity > 0 &&
      !this.product_1.should_be_added
    ) {
      this.updateProductFromCart({
        id: this.product_1.id,
        quantity: 0,
      });
    }
    if (itemsToAdd.length > 0) {
      this.addProductToCart({
        items: itemsToAdd,
      });
    }
  }

  addProductToCart({ items }) {
    console.log("addProductToCart", items);
    const body = JSON.stringify({
      items: items,
      sections: this.cart.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_add_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => response.json())
      .then((data) => {
        if (this.cart) this.cart.renderContents(data);
      })
      .catch((error) => console.error("Error adding product to cart:", error));
  }

  updateProductFromCart({ id, quantity }) {
    console.log("updateProductFromCart", { id, quantity });
    const body = JSON.stringify({
      id: id + "",
      quantity: quantity,
      sections: this.cart.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => response.json())
      .then((data) => {
        if (this.cart) this.cart.renderContents(data);
      })
      .catch((error) =>
        console.error("Error removing product from cart:", error)
      );
  }
}
customElements.define("free-product", FreeProduct);
